import React from "react";
import ReactDOM from "react-dom";
import cx from "classnames";

import "./styles/main.css";
import "./styles/drawer.css";
import "./styles/copybar.css";
import "./styles/pages.css";

import AboutPage from "./pages/AboutPage.js";
import AuthorPage from "./pages/AuthorPage.js";
import ChangelogPage from "./pages/ChangelogPage.js";

import GithubIcon from "./component/GithubIcon";

function Drawer({ id, isVisible = true, children }) {
  return (
    <div id={id} className={cx("Drawer", { "Drawer--visible": isVisible })}>
      <a className="Drawer-backdrop" href="#" aria-label="Close" />
      <div className="Drawer-panel">{children}</div>
    </div>
  );
}
function AppHeader() {
  return (
    <header className="App-header">
      <div className="Header">
        <a href="https://github.com/rumkin/copybar">
          <GithubIcon size={18} />
        </a>
      </div>
    </header>
  );
}

function CopyBar({
  className = "Copybar",
  aboutUrl = "#about",
  author,
  authorUrl = "#author",
  year,
  changelogUrl = "#changelog",
}) {
  return (
    <div className={className}>
      <a href={aboutUrl} title="About this app">
        ©
      </a>
      <a href={authorUrl} title="About the author">
        {author}
      </a>
      <a href={changelogUrl} title="Changelog">
        {year}
      </a>
    </div>
  );
}

function App({ hash }) {
  return (
    <div className="App">
      <AppHeader />
      <main className="App-main">
        <CopyBar author="Rumkin" year={2019} />
      </main>
      <Drawer id="about" isVisible={hash === "about"}>
        <AboutPage />
      </Drawer>
      <Drawer id="author" isVisible={hash === "author"}>
        <AuthorPage />
      </Drawer>
      <Drawer id="changelog" isVisible={hash === "changelog"}>
        <ChangelogPage />
      </Drawer>
    </div>
  );
}

const rootElement = document.getElementById("root");
const render = hash => {
  ReactDOM.render(<App hash={hash} />, rootElement);
};

render(window.location.hash.slice(1));

window.addEventListener("hashchange", () => {
  render(window.location.hash.slice(1));
});
